import { DropTarget } from 'react-dnd';
import { isNumber } from 'lodash';
import { ItemTypes } from 'constants/itemTypes';

const adderTarget = {
  drop(props, monitor, component) {
    const { position: oldPosition, parent_id } = monitor.getItem();
    const ownPosition = props.position;
    const isChild = isNumber(parent_id);

    const movedUp = ownPosition < oldPosition;
    const newPosition = movedUp ? ownPosition : ownPosition - 1;

    return { newPosition, detached: isChild };
  },
  canDrop(props, monitor) {
    const { position: ownPosition } = props;
    const { position, parent_id } = monitor.getItem();
    const isDistant = ownPosition !== position && ownPosition !== position + 1;
    const isChild = isNumber(parent_id);
    return isChild || isDistant;
  },
};

const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
});

export default DropTarget([ItemTypes.ELEMENT], adderTarget, collect);
